import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { SITE } from "@/lib/site";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you submit the estimate form on this website, we collect your name, email address, phone number, and property address. We use this information for one purpose only: to contact you about your project — scheduling an inspection, preparing your written estimate, and answering your questions.",
  },
  {
    title: "What we never do",
    body: "We never sell, rent, or trade your personal data to anyone, for any reason. We do not share your information for marketing purposes, and we do not add you to mailing lists you did not ask for.",
  },
  {
    title: "How your information is handled",
    body: "Form submissions are delivered to our office email and stored securely. We keep your information only as long as needed to respond to your request and, if you hire us, to complete your project.",
  },
  {
    title: "Questions",
    body: `Questions about this policy or your information can be sent to ${SITE.email} or by calling ${SITE.phone}.`,
  },
];

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy | Everstone Roofing Inc";
    window.scrollTo(0, 0);
    return () => {
      document.title = "Roofing Contractor in Milwaukee & Franklin, WI | GAF Certified | Everstone Roofing";
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#101010] text-white">
      <Navbar />
      <main>
        <section
          data-testid="privacy-page"
          className="theme-light relative bg-white py-24 lg:py-32 pt-40"
        >
          <div className="max-w-3xl mx-auto px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4A84B]" />
              <span className="es-label text-[#D4A84B]">Everstone Roofing Inc</span>
            </div>
            <h1
              data-testid="privacy-title"
              className="font-serif-display text-[#101010] text-4xl sm:text-5xl leading-[1.05] tracking-tight"
            >
              Privacy Policy
            </h1>
            <p className="text-[#6B7280] text-sm mt-4">Last updated: October 2026</p>

            <div className="mt-12 space-y-10">
              {SECTIONS.map((s, i) => (
                <div key={i} data-testid={`privacy-section-${i}`}>
                  <h2 className="font-serif-display text-[#101010] text-2xl leading-tight">
                    {s.title}
                  </h2>
                  <p className="text-[#4B5055] text-base leading-relaxed mt-3">
                    {s.body}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-14 border-t border-[#E5E7EB] pt-8">
              <a
                href="/"
                data-testid="privacy-back-home"
                className="text-[#D4A84B] hover:text-[#FFBF00] text-sm font-semibold underline underline-offset-4 decoration-[#D4A84B]/40 transition-colors"
              >
                ← Back to everstoneroofing.com
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
